import { IconProps } from "@/src/sb/business-layer/types"

const ArrowLeft = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M10 6H3M3 6L6.5 9.5M3 6L6.5 2.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowLeft
